module.exports = __webpack_public_path__ + "static/img/4202_phase_function_Paper_PointsHejduk_Prediction.6a581c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4202_phase_function_Paper_PointsHejduk_Prediction.png
// module id = DERU
// module chunks = 0